import styled from "styled-components";


const tokens = {
  blue: '#2251FF',
  blueDark: '#2251cc',
  blueLight: 'rgb(230, 236, 255)',
  grayBorder: '#E6E6E6',
  grayBorderInput: '#B3B3B3',
  grayText: '#757575',
  grayTextDark: '#333333',
  grayBg: '#f2f2f2',
  grayBgLight: '#fafafa',
  white: '#FFFFFF',
  radius: '10px',
  radiusSm: '4px',
  fontFamily: "'McKinsey Sans', 'McKinsey Sans Regular', 'Helvetica Neue', Calibri, sans-serif",
};


export const DatasetTreeLeftWrapper = styled.div`
    width: 100%;
    min-height: 200px;
    font-family: ${tokens.fontFamily} !important;
    .dataset-tree-loading {
        padding: 16px;
        color: ${tokens.grayText};
        font-size: 14px;
        font-weight: 400;
        font-family: ${tokens.fontFamily} !important;
    }
    .dataset-tree {
        .dataset-group {
            margin-bottom: 0;
        }
        .dataset-group-dropdown {
            margin-bottom: 20px;
            display: flex;
            flex-direction: column;
            gap: 8px;
            padding: 10px 12px;
            box-sizing: border-box;
        }
        /* Highlight whole dataset-group-dropdown in light blue when a dataset is selected */
        .dataset-group-dropdown:has(.dataset-dropdown-wrap.selected),
        .dataset-group-dropdown:has(.SelectContainer.selected) {
            background: ${tokens.blueLight};
            border-radius: 6px;
        }
        .dataset-group-label-wrap {
            display: flex;
            align-items: center;
            gap: 6px;
            margin-bottom: 6px;
            min-height: 20px;
        }
        .dataset-group-label-wrap .dataset-group-label {
            margin: 0;
            flex: 1;
            min-width: 0;
        }
        .dataset-group-dropdown .dataset-info-link {
            flex-shrink: 0;
            margin: 0;
            padding: 0;
            min-width: 20px;
            height: 20px;
            border: none;
            background: none;
            color: ${tokens.blue};
            font-family: ${tokens.fontFamily} !important;
            font-size: 12px;
            font-weight: 500;
            line-height: 1;
            cursor: pointer;
            border-radius: 2px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            transition: color 0.15s ease;
        }
        .dataset-group-dropdown .dataset-info-link:hover {
            color: ${tokens.blueDark};
        }
        .dataset-group-dropdown .dataset-info-icon {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            line-height: 0;
        }
        .dataset-group-dropdown .dataset-info-icon svg {
            display: block;
        }
        .dataset-group-label {
            font-family: ${tokens.fontFamily} !important;
            font-size: 16px;
            font-weight: 400;
            color: ${tokens.grayTextDark};
            display: block;
            margin: 0 0 6px 0;
            line-height: 20px;
        }
        .dataset-group-dropdown .dataset-dropdown-wrap,
        {
            width: 100%;
        }
        .dataset-group-dropdown .SelectContainer
        {
        width: 100%;
        min-width: 150px;
        max-width: 300px;
        }
        .dataset-group-dropdown .dataset-dropdown-wrap select,
        .dataset-group-dropdown .dataset-dropdown-wrap [class*="mds-select"],
        .dataset-group-dropdown .dataset-dropdown-wrap [class*="Select"],
        .dataset-group-dropdown .SelectContainer .Select {
            font-family: ${tokens.fontFamily} !important;
            font-size: 16px;
            font-weight: 400;
            color: ${tokens.grayTextDark};
            line-height: 20px;
            box-sizing: border-box;
        }
        .dataset-group-dropdown .dataset-dropdown-wrap button[aria-haspopup="listbox"],
        .dataset-group-dropdown .dataset-dropdown-wrap [role="combobox"],
        .dataset-group-dropdown .dataset-dropdown-wrap [class*="trigger"],
        .dataset-group-dropdown .SelectContainer button[aria-haspopup="listbox"],
        .dataset-group-dropdown .SelectContainer [role="combobox"] {
            font-family: ${tokens.fontFamily} !important;
            font-size: 16px;
            font-weight: 400;
            color: ${tokens.grayTextDark};
            min-height: 34px;
            height: auto !important;
            padding: 5px 28px 5px 12px;
            border: 1px solid ${tokens.grayBorderInput};
            border-radius: 4px;
            background: ${tokens.white};
            width: 100%;
            box-shadow: none;
            -webkit-box-shadow: none;
            transition: border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
        }
        .dataset-group-dropdown .dataset-dropdown-wrap button[aria-haspopup="listbox"]:focus,
        .dataset-group-dropdown .dataset-dropdown-wrap [role="combobox"]:focus,
        .dataset-group-dropdown .dataset-dropdown-wrap [class*="trigger"]:focus,
        .dataset-group-dropdown .SelectContainer button[aria-haspopup="listbox"]:focus,
        .dataset-group-dropdown .SelectContainer [role="combobox"]:focus {
            outline: none;
            border-color: ${tokens.blue};
            box-shadow: 0 0 0 2px rgba(34, 81, 255, 0.2);
        }
        .dataset-group-dropdown .dataset-dropdown-wrap button[aria-haspopup="listbox"]:hover,
        .dataset-group-dropdown .dataset-dropdown-wrap [role="combobox"]:hover,
        .dataset-group-dropdown .SelectContainer button[aria-haspopup="listbox"]:hover,
        .dataset-group-dropdown .SelectContainer [role="combobox"]:hover {
            border-color: ${tokens.blue};
            color: ${tokens.blueDark};
        }
        
        .dataset-group-dropdown .dataset-dropdown-wrap.selected button[aria-haspopup="listbox"],
        .dataset-group-dropdown .dataset-dropdown-wrap.selected [role="combobox"],
        .dataset-group-dropdown .SelectContainer.selected button[aria-haspopup="listbox"],
        .dataset-group-dropdown .SelectContainer.selected [role="combobox"],
        .dataset-group-dropdown .SelectContainer .Select--selected button[aria-haspopup="listbox"],
        .dataset-group-dropdown .SelectContainer .Select--selected [role="combobox"] {
            border-color: ${tokens.blue};
            color: ${tokens.blue};
        }
        .dataset-group-header {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 14px 16px;
            cursor: pointer;
            border: none;
            background: transparent;
            width: 80%;
            text-align: left;
            font-family: ${tokens.fontFamily} !important;
            font-size: 14px;
            font-weight: 400;
            color: ${tokens.grayTextDark};
            line-height: 1.4;
            border-radius: ${tokens.radiusSm};
            transition: color 0.15s, background 0.15s;
            &:hover {
                color: ${tokens.blueDark};
                background: ${tokens.grayBg};
            }
            &:focus {
                outline: 2px solid ${tokens.blue};
                outline-offset: 2px;
            }
        }
        .dataset-group-title {
            flex: 1;
        }
        .dataset-group-badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 26px;
            height: 26px;
            padding: 0 7px;
            border-radius: 50%;
            background: ${tokens.blue};
            color: #fff;
            font-size: 12px;
            font-weight: 600;
        }
        .dataset-group-toggle {
            color: ${tokens.blue};
            font-size: 16px;
            line-height: 1;
            font-weight: 400;
        }
        .dataset-group-list {
            list-style: none;
            margin: 0;
            padding: 4px 0 0 14px;
            margin-left: 18px;
        }
        .dataset-group-list li {
            margin: 0;
        }
        .dataset-group-list-item {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            margin-bottom: 8px;
        }
        .dataset-info-link {
            margin-top: -4px;
            margin-left: 0;
            padding: 0;
            border: none;
            background: none;
            color: ${tokens.blue};
            font-family: ${tokens.fontFamily} !important;
            font-size: 14px;
            font-weight: 400;
            cursor: pointer;
            text-align: left;
            line-height: 20px;
            &:hover {
                color: ${tokens.blueDark};
                text-decoration: underline;
            }
            &:focus {
                outline: 2px solid ${tokens.blue};
                outline-offset: 2px;
            }
        }
        .dataset-item {
            font-family: ${tokens.fontFamily} !important;
            display: block;
            width: 100%;
            padding: 12px 14px;
            margin: 2px 0;
            border: none;
            background: none;
            text-align: left;
            font-size: 14px;
            color: ${tokens.grayTextDark};
            cursor: pointer;
            border-radius: ${tokens.radiusSm};
            transition: background 0.15s, color 0.15s;
            border-left: 3px solid transparent;
            &:hover {
                color: ${tokens.blueDark};
                background: ${tokens.grayBg};
            }
            &.selected {
                color: ${tokens.blue};
                font-weight: 600;
                background: ${tokens.blueLight};
                border-left-color: ${tokens.blue};
            }
            &:focus {
                outline: 2px solid ${tokens.blue};
                outline-offset: 2px;
            }
        }
    }

    /* Internal user: preselected row per parent, no dropdown */
    .dataset-tree-internal {
        display: flex;
        flex-direction: column;
        gap: 0;
    }
    .dataset-group-internal {
        margin-bottom: 16px;
        display: flex;
        flex-direction: column;
        gap: 6px;
    }
    .dataset-group-internal-parent {
        font-family: ${tokens.fontFamily} !important;
        font-size: 14px;
        font-weight: 600;
        color: ${tokens.grayTextDark};
        line-height: 20px;
        padding: 0 2px;
    }
    .dataset-group-internal-row-wrap {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-left: 10px;
    }
    .dataset-tree-internal .dataset-preselected-row {
        flex: 1;
        min-width: 0;
        font-family: ${tokens.fontFamily} !important;
        font-size: 14px;
        font-weight: 400;
        padding: 10px 12px;
        margin: 0;
        border: none;
        background: ${tokens.grayBgLight};
        text-align: left;
        color: ${tokens.grayTextDark};
        cursor: pointer;
        border-radius: ${tokens.radiusSm};
        border-left: 3px solid transparent;
        transition: background 0.15s, color 0.15s, border-color 0.15s;
        margin-bottom: 10px;
    }
    .dataset-tree-internal .dataset-preselected-row:hover {
        color: ${tokens.blueDark};
        background: ${tokens.grayBg};
    }
    .dataset-tree-internal .dataset-preselected-row.selected {
        color: ${tokens.blue};
        font-weight: 600;
        background: ${tokens.blueLight};
        border-left-color: ${tokens.blue};
    }
    .dataset-tree-internal .dataset-preselected-row:focus {
        outline: 2px solid ${tokens.blue};
        outline-offset: 2px;
    }
    .dataset-info-link-internal {
        flex-shrink: 0;
        margin: 0;
        padding: 4px;
        min-width: 28px;
        height: 28px;
        border: none;
        background: none;
        color: ${tokens.blue};
        font-family: ${tokens.fontFamily} !important;
        cursor: pointer;
        border-radius: 2px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        transition: color 0.15s ease;
        margin-right: 5px;
    }
    .dataset-info-link-internal:hover {
        color: ${tokens.blueDark};
        background: ${tokens.grayBg};
    }

    /* Release sections (non-GGC admin): Latest Release / Previous Release */
    .dataset-tree-internal-wrap {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }
    .release-section {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
    /* Indent dataset list under release heading without causing overflow (padding stays inside width) */
    .release-section .dataset-tree-dropdowns {
        box-sizing: border-box;
        min-width: 0;
        margin-left: 10px;
        margin-right: 10px;
    }
    .release-section-heading {
        font-family: ${tokens.fontFamily} !important;
        font-size: 18px;
        font-weight: 600;
        color: ${tokens.grayTextDark};
        line-height: 20px;
        margin: 0 0 4px 0;
        padding: 0 2px;
    }
`;

export const Wrapper = styled.div`
    padding : 16px 32px;
    display : flex;
    gap : 0;
    /* Fill viewport below header/footer so only inner panels scroll (no main page scroller) */
    height: calc(100vh - 180px);
    min-height: 0;
    overflow: hidden;
    .mds-alert{
        top : 90px;
        background: #051C2C;
        position : fixed;
        left : 0;
        width : 100vw;
        box-sizing: border-box;
        padding-right : 32px;
        z-index: 9999;
        a{
            color : #fff !important;
            text-decoration: underline !important;
        }
    }

    .reportPopupWrapper {
        width : 100vw;
        height : 100vh;
        position : fixed;
        z-index : 11;
        background : rgba(0,0,0,0.4);
        top : 0;
        bottom : 0;
        left : 0;
        right : 0;
        display : flex;
        align-items: center;
        justify-content: center;
        .reportPopup{
          min-width: 320px;
          box-sizing: border-box;
          background-color: #fff;
          padding : 40px;
          h1{
            font-size: 24px;
            font-weight: 500;
          }
          p{
            font-size: 14px;
            color : rgb(51,51,51);
            margin-top : 10px;
          }
          input[type=text]{
            color: #333;
            background-color: #fff;
            border: 1px solid #ccc;
            width: 100%;
            height: 38px;
            margin : 50px 0;
            padding: 8px 12px;
            font-size: 14px;
            line-height: 1.42857;
            box-sizing: border-box;
            display: block;
          }
          .buttons{
            display: flex;
            gap : 10px;
            justify-content: center;
          }
        }
    }
    .hideChildren {
        display: none;
    }
    .cursor-default {
        cursor: default;
    }
    h1{
        font-size : 20px;
        font-weight : 400;
        margin-bottom : 16px;
        display : flex;
        align-items : center;
        line-height : 28px;
        gap : 8px;
        svg{
            height : 18px;
            cursor: pointer;
        }
    }

    .dataset-publication{
        display : flex;
        gap : 16px;
        label{
            line-height : 24px;
            margin-bottom : 8px;
        }
        >div{
            >*{
                display : block;
            }
        }
    }

    .dataset-info{
        margin-bottom : 24px;
        color :rgb(3, 14, 53);
        display : inline-block;
        background : none;
        border : none;
        margin-top : 4px;
        font-weight : 500;
        font-size : 14px;
    }

    .left-sidebar {
        min-width: 150px;
        max-width: 310px;
        width: 100%;
        background: ${tokens.white};
        padding: 10px;
        display: flex;
        flex-direction: column;
        gap: 0;
        min-height: 0;
        align-self: stretch;
        overflow: hidden;
        border-right: 1px solid ${tokens.grayBorder};
        font-family: ${tokens.fontFamily} !important;
        color: ${tokens.grayTextDark};
    }
    .left-sidebar .dataset-tree-loading,
    .left-sidebar .dataset-group-label,
    .left-sidebar .dataset-info-link,
    .left-sidebar select,
    .left-sidebar button {
        font-family: ${tokens.fontFamily} !important;
    }
    /* Native select in left sidebar – eco-style (AdvancedSearch Dropdown + FilterCard hover) */
    .left-sidebar select {
        font-size: 14px;
        font-weight: 400;
        color: ${tokens.grayTextDark};
        min-height: 40px;
        padding: 8px 32px 8px 16px;
        border: 1px solid #ccc;
        border-radius: 6px;
        background: ${tokens.white};
        width: 100%;
        cursor: pointer;
        appearance: none;
        -webkit-appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23333' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 12px center;
        transition: border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
    }
    .left-sidebar select:hover {
        border-color: ${tokens.blue};
        color: ${tokens.blueDark};
    }
    .left-sidebar select:focus {
        outline: none;
        border-color: ${tokens.blue};
        box-shadow: 0 0 0 2px rgba(34, 81, 255, 0.2);
    }
    .left-sidebar-tree-wrap {
        flex: 1 1 auto;
        min-height: 0;
        display: flex;
        flex-direction: column;
        gap: 0;
        overflow: auto;
    }
    .left-sidebar-dataset-tree {
        flex-shrink: 0;
    }

    /* Main content: Select data (dimensions + attributes) + Save selection/ Generate */
    .main-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-width: 0;
        min-height: 0;
        padding-left: 15px;
        /* Contain to flex chain so only inner panes (dimension list, left nav) scroll at any zoom */
        overflow: hidden;
    }

    /* Dataset context heading: shows the selected dataset name (and version subtext for admins)
       so users always know which dataset their selections will be applied to. */
    .dataset-context-header {
        display: flex;
        flex-direction: column;
        gap: 2px;
        padding: 8px 4px 12px;
        margin-bottom: 8px;
        border-bottom: 1px solid ${tokens.grayBorder};
        flex-shrink: 0;
        min-width: 0;
    }
    .dataset-context-header .dataset-context-name {
        margin: 0;
        font-family: ${tokens.fontFamily} !important;
        font-size: 20px;
        font-weight: 600;
        line-height: 1.3;
        color: ${tokens.grayTextDark};
        max-width: 100%;
        white-space: normal;
        word-break: break-word;
    }
    .dataset-context-header .dataset-context-version {
        font-family: ${tokens.fontFamily} !important;
        font-size: 13px;
        font-weight: 400;
        color: ${tokens.grayText};
        line-height: 1.45;
        max-width: 100%;
        white-space: normal;
        word-break: break-word;
    }

    .select-data-layout {
        flex: 1;
        min-height: 0;
        display: flex;
        align-items: stretch;
        gap: 10px;
        min-width: 0;
        overflow: hidden;
    }

    .select-data-left {
        min-width: 250px;
        max-width: 500px;
        flex: 0 0 auto;
        border-right: 1px solid ${tokens.grayBorder};
        padding-right: 10px;
        margin-right: 0;
        display: flex;
        flex-direction: column;
        min-height: 0;
        max-height: 100%;
        overflow: auto;
        h2.select-data-heading {
            font-size: 16px;
            font-weight: 600;
            color: rgb(51, 51, 51);
            margin: 0 0 12px 0;
            padding-bottom: 8px;
            border-bottom: 1px solid ${tokens.grayBorder};
        }
        .dimension-nav {
            flex: 1 1 auto;
            min-width: 0;
            min-height: 0;
            overflow: auto;
            -webkit-overflow-scrolling: touch;
            padding-top: 10px;
        }
        .dimension-nav-list {
            list-style: none;
            margin: 0;
            padding: 0;
        }
        .dimension-nav-item {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            width: 100%;
            padding: 10px 12px;
            margin: 2px 0;
            border: none;
            background: none;
            text-align: left;
            font-size: 15px;
            color: ${tokens.grayTextDark};
            cursor: pointer;
            border-radius: ${tokens.radiusSm};
            transition: background 0.15s, color 0.15s;
            border-left: 5px solid transparent;
            &:hover {
                color: ${tokens.blueDark};
                background: ${tokens.grayBg};
            }
            &.active {
                color: ${tokens.blueDark};
                font-weight: 600;
                background: ${tokens.blueLight};
                border-left-color: ${tokens.blue};
            }
            &:focus {
                outline: 2px solid ${tokens.blue};
                outline-offset: 2px;
            }
            .dimension-nav-label {
                display: block;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                max-width: 100%;
                font-size: 16px;
                font-family: ${tokens.fontFamily};
            }
            .dimension-nav-count {
                font-size: 12px;
                font-weight: 400;
                color: ${tokens.grayText};
                margin-top: 2px;
            }
            &.active .dimension-nav-count { color: ${tokens.blueDark}; }
        }
        .apply-section {
            flex-shrink: 0;
            margin-top: auto;
            padding: 16px;
            background: ${tokens.grayBgLight};
            border-radius: ${tokens.radius};
            border: 1px solid ${tokens.grayBorder};
        }
        .apply-section button {
            min-height: 44px;
            font-weight: 600;
        }
    }

    .select-data-right {
        flex: 1 1 0;
        min-width: 0;
        min-height: 0;
        /* stretch with left column; do not shrink-wrap (was align-self: flex-start) or list cannot fill height */
        align-self: stretch;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }
    .select-data-right .filter-section {
        flex-shrink: 0;
        margin-bottom: 8px;
    }
    .select-data-right .dimension-attributes {
        flex: 1 1 auto;
        min-height: 0;
        min-width: 0;
        display: flex;
        flex-direction: column;
        /* Scroll lives on .dimension so title stays visible */
        overflow: hidden;
    }
    .additional-resources-wrap {
        flex-shrink: 0;
        margin-top: 24px;
    }

    /* Select All / None / Invert – link-style controls */
    .short-filters {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        align-items: center;
        padding: 10px 0;
        font-size: 16px;
        margin-bottom: 16px;
        label {
            font-weight: 600;
            color: ${tokens.grayTextDark};
            margin-right: 4px;
        }
        .flex1 {
            display: flex;
            align-items: center;
            gap: 4px;
            flex-wrap: wrap;
        }
        input[type="button"] {
            padding: 6px 12px;
            font-size: 14px;
            font-weight: 500;
            border: none;
            background: none;
            color: ${tokens.grayText};
            cursor: pointer;
            border-radius: ${tokens.radiusSm};
            transition: color 0.15s, background 0.15s;
            &:hover:not(.cursor-default) {
                color: ${tokens.blue};
                background: ${tokens.grayBg};
            }
            &.active {
                color: ${tokens.blue};
                font-weight: 600;
                background: ${tokens.blueLight};
            }
            &.cursor-default {
                cursor: default;
            }
        }
        .definitions {
            margin-left: 8px;
        }
    }

    /* Right pane: dimension content (heading, search, tree) */
    .select-data-right h1.dimension-heading {
        font-size: 18px;
        font-weight: 600;
        color: rgb(51, 51, 51);
        margin: 0 0 12px 0;
        padding-bottom: 8px;
        border-bottom: 1px solid ${tokens.grayBorder};
        line-height: 1.3;
        flex-shrink: 0;
    }
    .select-data-right .dimension {
        flex: 1 1 auto;
        min-height: 0;
        min-width: 0;
        max-height: none;
        width: 100%;
        box-sizing: border-box;
        overflow-y: auto;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
        border: 1px solid ${tokens.grayBorder};
        border-radius: ${tokens.radius};
        background: ${tokens.white};
        padding: 6px 8px 6px 0;
    }
    .select-data-right .popup-item {
        .radio {
            padding: 10px 12px;
            border-bottom: 1px solid ${tokens.grayBorder};
            display: flex;
            flex-direction: row-reverse;
            justify-content: space-between;
            align-items: center;
            min-height: 44px;
            line-height: 1.5;
            gap: 12px;
            box-sizing: border-box;
        }
        .radio label {
            flex: 1;
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            display: flex;
            align-items: center;
            min-height: 24px;
        }
        .flex {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 12px;
            border-bottom: 1px solid ${tokens.grayBorder};
            transition: background 0.15s;
            min-height: 44px;
            line-height: 1.5;
            gap: 12px;
            min-width: 0;
            box-sizing: border-box;
            &:hover {
                background: ${tokens.grayBg};
            }
        }
        .flex .tree-gutter {
            flex-shrink: 0;
            width: 32px;
            min-width: 32px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            align-self: center;
            box-sizing: border-box;
        }
        .info {
            flex: 1;
            min-width: 0;
            padding: 0;
            cursor: pointer;
            overflow: hidden;
            display: flex;
            align-items: center;
            min-height: 24px;
            .attribute-name {
                color: ${tokens.grayTextDark};
                line-height: 1.5;
                font-size: 14px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin: 0;
            }
            .comment {
                font-size: 12px;
                color: ${tokens.grayText};
                line-height: 1.3;
                margin: 2px 0 0 0;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            &:hover p { color: ${tokens.blue}; }
        }
        .tree-selector-cell {
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            min-width: 28px;
            align-self: center;
        }
        .tree-selector-cell > * {
            flex-shrink: 0;
            vertical-align: middle;
        }
        .collapsiable-checkbox .parent {
            color: ${tokens.grayTextDark};
            .flex {
                border-bottom: 1px solid ${tokens.grayBorder};
                padding: 10px 12px;
                min-height: 44px;
            }
        }
        .collapsiable-checkbox{
                .parent{
                    color : rgb(77, 77, 77);
                    box-sizing: border-box;
                    svg{
                        cursor : pointer;
                        min-width : 16px;
                        transition : 0.4s;
                        &.open{
                            transform : rotateX(180deg)
                        }
                    }
                }

                .children {
                    color : rgb(77, 77, 77);
                    box-sizing: border-box;
                    /* Indent on each .flex row (CollapsibleAttributeTree) so borders span full width */
                    padding-left: 0;
                    transition : 0.4s;
                    &.close{
                        height : 0;
                        overflow : hidden;
                    }
                }
            }
        /* Stepped levels for legacy; depth indent is on rows via paddingLeft in CollapsibleAttributeTree. */
        .tree-level-0 { padding-left: 0; }
        .tree-level-1 { padding-left: 20px; }
        .tree-level-2 { padding-left: 40px; }
        .tree-level-3 { padding-left: 60px; }
        .tree-level-4 { padding-left: 80px; }
        .tree-level-5 { padding-left: 100px; }
        .tree-node-count {
            font-size: 12px;
            font-weight: 400;
            color: ${tokens.grayText};
            margin-left: 6px;
        }
        label > div { min-width: 20px; }
    }

    .select-data-empty {
        padding: 48px 24px;
        color: rgb(117, 117, 117);
        font-size: 16px;
        line-height: 1.5;
    }

    .left {
        flex : 1;
        max-width : calc(100% - 300px - 16px);

        .title {
            border: none;
            padding: 4px;
            font-size: 20px;
            width: 200px;
            line-height: 20px;
        }

        .title:focus {
            outline-offset: 0px;
            background-color: #e6e9f5;
            outline: 2px solid #e6e9f5;
        }

        .filter-section{
            .instructions{
                color : rgb(117, 117, 117);
                font-size : 16px;
            }

            .filters{
                display : flex;
                align-items : center;
                gap : 8px;
                padding : 16px 0;
                .filter{
                    padding : 10px;
                    display : flex;
                    align-items: center;
                    gap : 10px;
                    cursor : pointer;
                    font-size : 16px;
                    border : solid thin rgb(204, 204, 204);
                    &:hover{
                        color : #2251cc;
                        border : solid thin #2251cc;
                    }
                    &.active{
                        color : #2251cc;
                        border : solid thin #2251cc;
                    }
                }
            }

            .search{
                border : solid thin rgb(204, 204, 204);
                font-size : 16px;
                line-height : 24px;
                padding : 8px 16px;
                width : 100%;
            }

            .short-filters{
                display : flex;
                gap : 16px;
                padding : 16px 0;
                align-items : center;
                font-size : 14px;
                label{
                    font-weight : bold;
                    font-size : 14px;
                }
                input[type=button]{
                    padding : 8px;
                    font-size : 14px;
                    border : none;
                    background : none;
                    &.active{
                        color : #2251ff;
                        border-bottom : solid thin #2251ff;
                    }
                }
                .flex1 {
                    flex : 1;
                }

                .definitions{
                    border-bottom : solid thin #fff !important;
                    &:hover{
                        color : #2251ff;
                        border-bottom : solid thin #2251ff !important;
                    }
                }
            }
        }

        h1.dimension-heading{
            border-bottom : solid 2px #000;
            font-size : 24px;
            margin-top : 16px;
            line-height : 36px;
        }
        .dimension{
            max-height : 500px;
            overflow : auto;
            min-height : 300px;
        }

        .popup-item{

            .radio{
                padding : 8px 0;
                border-bottom : solid thin #ccc;
                display: flex;
                flex-direction: row-reverse;
                justify-content: space-between;
            }

            .flex{
                    display : flex;
                    align-items : center;
                    justify-content : space-between;
                    border-bottom : solid thin #ccc;
                    &:hover{
                        background : #f2f2f2;
                    }
                }
            .flex .tree-gutter {
                flex-shrink: 0;
                width: 32px;
                min-width: 32px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                align-self: center;
                box-sizing: border-box;
            }
            .info{
                    flex : 1;
                    padding : 8px 10px;
                    margin-right : 10px;
                    &:hover{
                        p{
                            color : #2251ff;
                        }
                        cursor : pointer;
                    }
                    .attribute-name{
                        color : rgb(77, 77, 77);
                        line-height : 24px;
                    }
                    .comment{
                        font-size : 14px;
                        color : rgb(51, 51, 51);
                    }
                }

            .collapsiable-checkbox{
                .parent{
                    color : rgb(77, 77, 77);
                    box-sizing: border-box;
                    svg{
                        cursor : pointer;
                        padding : 8px;
                        min-width : 16px;
                        transition : 0.4s;
                        &.open{
                            transform : rotateX(180deg)
                        }
                    }
                }

                .children {
                    color : rgb(77, 77, 77);
                    box-sizing: border-box;
                    padding-left: 0;
                    transition : 0.4s;
                    &.close{
                        height : 0;
                        overflow : hidden;
                    }
                }
            }

            label{
                &:hover{
                    background : #eee;
                }
                >div{
                    min-width : 20px;
                }
            }

        }

    }

    .right {
        width : 300px;
        position: fixed;
        right : 32px;
        >div{
            background : #f2f2f2;
            padding : 16px;
        }
        .apply-section{
            
            button{
                margin-bottom : 8px;
            }
            p{
                font-size : 14px;
                line-height: 20px;
                margin-bottom : 24px;
                color : rgb(77, 77, 77);
            }
        }
    }

    .dataset-info-popup{
        width : 100vw;
        height : 100vh;
        position : fixed;
        top : 0;
        left : 0;
        display : flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
        background : rgba(0,0,0,0.5);
        .dataset-info{
            width : 75%;
            position : relative;
            height : 90vh;
            background : #fff;
            color : #333;
            display : flex;
            svg{
                position : absolute;
                top : 10px;
                right : 20px;
                cursor: pointer;
            }
            .left-one {
                width : 28%;
                h1{
                    border-bottom: 1px solid #e6e6e6;
                    margin-bottom: 20px;
                    padding: 20px 32px;
                    display: flex;
                    text-align: left;
                    font-size: 24px;
                }
                >div{
                    border : none;
                }
            }
            .right-one {
                flex : 1;
                overflow : auto;
                border-left : solid thin #ccc;
                height : 90vh;
                box-sizing: border-box;
                padding : 32px 24px;
                .sub-heading{
                    font-size : 24px;
                    color : #2251ff;
                    margin-bottom : 16px;
                    font-weight: 100;
                }
                .heading{
                    font-size : 32px;
                    margin-bottom: 24px;
                    display : flex;
                    gap : 16px;
                    align-items: center;
                }
                /* Controlled tab nav (replaces MDS Tabs so we can switch tab programmatically). */
                .dataset-info-tabs {
                    display: flex;
                    gap: 0;
                    border-bottom: 1px solid #ccc;
                    margin-bottom: 0;
                }
                .dataset-info-tabs .dataset-info-tab {
                    background: transparent;
                    border: none;
                    border-bottom: 3px solid transparent;
                    padding: 12px 18px;
                    font-family: ${tokens.fontFamily} !important;
                    font-size: 15px;
                    font-weight: 400;
                    color: ${tokens.grayTextDark};
                    cursor: pointer;
                    transition: color 0.15s ease, border-color 0.15s ease;
                }
                .dataset-info-tabs .dataset-info-tab:hover {
                    color: ${tokens.blueDark};
                }
                .dataset-info-tabs .dataset-info-tab.is-active {
                    color: ${tokens.blue};
                    font-weight: 600;
                    border-bottom-color: ${tokens.blue};
                }
                .dataset-info-tabs .dataset-info-tab:focus-visible {
                    outline: 2px solid ${tokens.blue};
                    outline-offset: -2px;
                }
                >div>div{
                    height : 36px;
                    margin-bottom : 3px;
                }
                button{
                    
                    font-weight : 100;
                }
                .mds-tab-content{
                    border-top : solid thin #ccc;
                    padding: 32px 0;
                    p{
                        color : rgb(51, 51, 51);
                        font-size: 16px;
                        line-height: 24px;
                    }
                    h2:not(.sub-heading){
                        font-size : 16px;
                        margin-bottom : 4px;
                    }
                }
                /* Old portal styling: Overview (left panel style) */
                .dataset-info-overview {
                    color: #333333;
                    line-height: 1.6em;
                    margin: 0 -32px 0 -24px;
                    padding: 10px 20px;
                    font-size: 16px;
                }
                .dataset-info-overview .sub-heading {
                    color: #2251ff;
                    font-weight: 600;
                    font-size: 1.1rem;
                    margin-top: 0;
                    margin-bottom: 16px;
                    font-size: 16px;
                }
                .dataset-info-overview h1:not(.sub-heading) {
                    color: #2251ff;
                    font-weight: 700;
                    font-size: 1rem;
                    margin-top: 25px;
                    margin-bottom: 8px;
                    font-size: 16px;
                }
                .dataset-info-overview h2 {
                    color: #2251ff;
                    font-weight: 700;
                    font-size: 1rem;
                    margin-top: 20px;
                    margin-bottom: 6px;
                    font-size: 16px;
                }
                .dataset-info-overview p {
                    color: #333333;
                    font-size: 0.95em;
                    line-height: 1.6em;
                    margin: 0 0 8px 0;
                    padding-left: 0.5em;
                    font-size: 16px;

                }
                .dataset-info-overview br + p {
                    margin-top: 2px;
                    font-size: 16px;
                }
                /* Real Medium face (600); avoids fuzzy synthesized bold on Regular */
                .dataset-info-overview p strong {
                    font-family: 'McKinsey Sans', sans-serif;
                    font-weight: 600;
                    color: #111111;
                    font-size: 16px;
                }
                /* Old portal styling: Release Information (right panel style) */
                .dataset-info-release {
                    color: #333333;
                    line-height: 1.6em;
                    margin: 0 -32px 0 -24px;
                    padding: 10px 20px;
                    font-size: 16px;
                }
                .dataset-info-release .sub-heading {
                    color: #2251ff;
                    font-weight: 600;
                    font-size: 1.1rem;
                    margin-top: 0;
                    margin-bottom: 16px;
                    font-size: 16px;
                }
                .dataset-info-release h1:not(.sub-heading) {
                    color: #2251ff;
                    font-weight: 700;
                    font-size: 1rem;
                    margin-top: 25px;
                    margin-bottom: 10px;
                    font-size: 16px;
                }
                .dataset-info-release h2 {
                    color: #2251ff;
                    font-weight: 400;
                    font-size: 1rem;
                    margin-top: 15px;
                    margin-bottom: 6px;
                    font-size: 16px;
                }
                .dataset-info-release h3 {
                    color: #2251ff;
                    font-weight: 400;
                    font-size: 0.95em;
                    margin-top: 12px;
                    margin-bottom: 4px;
                    font-size: 16px;
                    text-decoration: underline;
                }
                .dataset-info-release p {
                    color: #333333;
                    font-size: 0.95em;
                    line-height: 1.6em;
                    margin: 0 0 8px 0;
                    padding-left: 1.5em;
                    position: relative;
                    font-size: 16px;
                }
                .dataset-info-release p::before {
                    content: "• ";
                    position: absolute;
                    left: 0;
                    color: #333333;
                    font-size: 16px;
                }
                .dataset-info-release p:first-of-type::before {
                    content: none;
                }
                .dataset-info-release p:first-of-type {
                    padding-left: 0;
                }
                .dataset-info-release h3 ~ p::before {
                    content: "• ";
                }
                .dataset-info-release p strong {
                    font-family: 'McKinsey Sans', sans-serif;
                    font-weight: 600;
                    color: #111111;
                    font-size: 16px;
                    letter-spacing: -0.01em;
                }
                .dataset-info-versions {
                    color: #333333;
                    line-height: 1.6em;
                    margin: 0 -32px 0 -24px;
                    padding: 10px 20px;
                    font-size: 16px;
                }
                .dataset-info-versions .sub-heading {
                    color: #2251ff;
                    font-weight: 600;
                    font-size: 1.1rem;
                    margin-top: 0;
                    margin-bottom: 16px;
                    font-size: 16px;
                }
                .dataset-info-versions .dataset-info-versions-list {
                    list-style: none;
                    margin: 0;
                    padding: 0;
                }
                .dataset-info-versions .dataset-info-versions-list li {
                    color: #333333;
                    font-size: 16px;
                    line-height: 1.6em;
                    margin: 0 0 8px 0;
                    padding-left: 0.5em;
                    list-style: none;
                }
                .dataset-info-versions .dataset-info-versions-option {
                    display: flex;
                    align-items: flex-start;
                    gap: 10px;
                    cursor: pointer;
                    font-size: 16px;
                    line-height: 1.5;
                }
                .dataset-info-versions .dataset-info-versions-option input {
                    margin-top: 4px;
                    flex-shrink: 0;
                }
            }
        }
    }
`

export const UpdateContainer = styled.div`
    color: #2251ff;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.5em;
    cursor: pointer;
`

export const ReadOnlyReportNameContainer = styled.div`
    min-width: fit-content;
    max-width: 100%;
    font-size: 20px;
    line-height: 20px;
    padding: 0px;
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: center;
`
